import type { Routes } from '@angular/router';

export const DASHBOARD_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#modules/dashboard/views/dashboard-entry/dashboard-entry.component').then((m) => m.DashboardEntryComponent),
    },
];
